/**
 * AUTOGENERATED FILE. DO NOT EDIT.
 *
 * This file is generated by running yarn i18n:build, do not edit it manually.
 *
 * If you wish to update it, please run yarn i18n:build.
 */
/* eslint-disable no-restricted-imports */
import {i18n} from "@lingui/core";
import * as React from "react";

import {RequestInfo} from "@repo/shared-core";

// We statically import the English strings as we use them as a fallback
// for locales that don't have any translations. Additionally, it improves
// the performance of the English site by not having to load the strings at
// runtime.
// NOTE(john): This is replaced with the actual English strings in the build
// process.
const enStrings = {"ivZpKd":["Share your story"],"K9VsXd":["Over 80 million lives have been impacted by Khan Academy, and they continue to inspire us every day."],"yz7wBu":["Close"],"t+LSkp":["We’re grateful for all of your stories, but please only share it if it is about you and you’re 13 years of age or over."],"FAQs7J":["How has Khan Academy changed your life?"],"q8yluz":["Your name"],"z8F4/3":["Your email"],"HKzeU1":["We may reach out to you and ask for your permission to share your story on our social media channels."],"aBNjod":["I'm using Khan Academy as a"],"fK15HT":["Select one"],"a0qEkS":["Student"],"lypRAW":["Teacher"],"sujToP":["Parent"],"q1PPtF":["Adult learner"],"LWX3Yw":["Level in school"],"y5Iu3m":["For example, 8th grade or Standard 8"],"WJsKAu":["Tell your story as a video"],"VkZUlY":["Optional - provide link to your video"],"CQnKcg":["I am 13 years of age or older"],"q1KMKn":["Khan Academy can share my story publicly, and I am 13 years of age or older"],"Sad2tK":["Sending…"],"hQRttt":["Submit"],"Dn+NK3":["Stories"],"Su4lmT":["Error retrieving data."]};

let results: Record<string, string | string[]> | undefined = undefined;
let promise: Promise<void> | null = null;

// We keep track of locales that are missing translations so we can load the
// English strings for those locales.
// NOTE(john): This array is replaced with the list of locales.
const missingTranslations: string[] = ["zh-hant","sk","sgn-us","lol","is","en-x-rtl","zu","xh","th","te","sw","fa","ms","he","fa-af","sq"];

// We keep track of locales that have been bundled together in the same file
// so we can load them all at once.
const extraLocales: string[] = ["es","zh-hans","vi","ur","uk","tr","sr","ro","pt","pl","pa","or","nb","ko","km","ka","hy","hi","fr","de","bn","bg","uz","ta","sv","rw","ru","pt-pt","nl","my","mr","mn","lv","lt","ky","kn","kk","ja","it","id","hu","gu","fv","en-pt","el","da","cs","boxes","as","az","accents","ar"];

/**
 * Load the i18n strings for the current locale and add them to the Lingui i18n
 * instance. This uses Suspsense so you'll want to make sure that your
 * component is wrapped in a Suspense (for loading) and an ErrorBoundary
 * (for errors).
 *
 * This function is called by the LoadStrings component, which is a Loadable
 * component that loads the strings for a route and all descendant imports.
 *
 * You can use this directly or you can use the withStrings HoC to load
 * strings for a component.
 */
export const useStrings = () => {
    if (results) {
        return results;
    }

    const locale = RequestInfo.kaLocale;

    // If the locale is English, or doesn't have any translations, we don't need to load
    // any additional strings.
    if (locale === "en" || missingTranslations.includes(locale)) {
        // Load the English strings into Lingui. This serves as a fallback for
        // locales that don't have any translations (and the actual strings for the English
        // locale).
        results = enStrings;
        i18n.load(locale, results);
        return results;
    }

    if (!promise) {
        promise = (async () => {
            const locale = RequestInfo.kaLocale;
            const localeFile = extraLocales.includes(locale) ? "extra" : locale;

            if (process.env.NODE_ENV === "production") {
                const result = (await import(`./lingui/${localeFile}.json`))
                    .default;
                results = localeFile === "extra" ? result[locale] : result;
            } else {
                results = {};
            }

            // Load the strings into Lingui
            i18n.load(locale, {...enStrings, ...results});

            promise = null;
        })();
    }

    throw promise;
};

/**
 * The HOC to load i18n strings for a route and all descendant imports.
 *
 * Examples:
 *
 * - export default withStrings(WrappedComponent);
 *
 * - export default compose(
 *      withStrings,
 *      withRouter
 *   )(WrappedComponent);
 */
export const withStrings = <C extends object>(
    WrappedComponent: React.ComponentType<C>,
) => {
    if (process.env.NODE_ENV === "test") {
        return WrappedComponent;
    }

    // Try to create a nice displayName for React Dev Tools.
    const displayName =
        WrappedComponent.displayName || WrappedComponent.name || "Component";

    // Creating the inner component.
    const WrapperComponent = (props: C): React.ReactNode => {
        useStrings();
        return <WrappedComponent {...(props as C)} />;
    };

    WrapperComponent.displayName = `withStrings(${displayName})`;

    return WrapperComponent;
};
